<app-page-header [title]="'Languages'" [subtitle]="'Manage languages for SampleStudio'"></app-page-header>
<div class="mb-6">
    <div class="flex justify-between mb-2">
        <p-ifta-label>
            <p-iconfield>
                <p-inputicon class="pi pi-search"></p-inputicon>
                <input pInputText id="language_search" [(ngModel)]="this.search" (input)="onSearchInputChange()"
                       autocomplete="off"/>
            </p-iconfield>
            <label for="language_search">Search language</label>
        </p-ifta-label>
        <p-button label="Add Language" icon="pi pi-plus" (click)="this.openCreateLanguageDialog()" isAdmin
                  [hidden]="false"></p-button>
    </div>
    <div class="border border-gray-300 dark:border-gray-700 p-2 dark:p-0 mb-5 rounded-sm">
        <p-table
                [value]="this.languages"
                [paginator]="true"
                [rows]="this.rows"
                [totalRecords]="this.totalRecords"
                [lazy]="true"
                [first]="this.currentPage * this.rows"
                [loading]="this.loading"
                [rowsPerPageOptions]="[5, 10, 20]"
                (onLazyLoad)="this.onPageChange($event)"
        >
            <ng-template pTemplate="header">
                <tr>
                    <th>Name</th>
                    <th>Locale Key</th>
                    <th></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-language>
                <tr>
                    <td>{{ language.name }}</td>
                    <td>{{ language.localeKey }}</td>
                    <td>
                        <div class="flex justify-end">
                            <p-button icon="pi pi-eye" text
                                      pTooltip="View language"
                                      tooltipPosition="left"
                                      routerLink="/languages/language/{{language.id}}"></p-button>

                            <p-button icon="pi pi-pencil" text
                                      isAdmin
                                      pTooltip="Edit language"
                                      tooltipPosition="left"
                                      (click)="this.editLanguage(language)"></p-button>

                            <p-button icon="pi pi-trash" text
                                      isAdmin
                                      pTooltip="Delete language"
                                      tooltipPosition="left"
                                      (click)="this.deleteLanguage(language)"
                                      severity="danger"></p-button>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>
<div class="flex gap-2 mb-6">
    <p-button label="Export all Languages" icon="pi pi-download" (click)="this.exportLanguages()"
              severity="secondary"></p-button>
</div>

<!-- Create Language Dialog -->
<app-create-language-dialog
        [(visible)]="this.displayCreateLanguageDialog"
        (languageCreated)="this.reloadLanguages()"
></app-create-language-dialog>

<!-- Update Language Dialog -->
<app-update-language-dialog
        [(visible)]="this.displayUpdateLanguageDialog"
        [language]="this.selectedLanguage"
        (languageUpdated)="this.reloadLanguages()"
></app-update-language-dialog>
